import player10ImageSource from "../../../../assets/photos/players/player-10.jpeg";
import player2ImageSource from "../../../../assets/photos/players/player-2.jpeg";
import player23ImageSource from "../../../../assets/photos/players/player-23.jpeg";
import player14ImageSource from "../../../../assets/photos/players/player-14.jpeg";
import player32ImageSource from "../../../../assets/photos/players/player-32.jpeg";
import player4ImageSource from "../../../../assets/photos/players/player-4.jpeg";
import player15ImageSource from "../../../../assets/photos/players/player-15.jpeg";
import player99ImageSource from "../../../../assets/photos/players/player-99.jpeg";
import player22ImageSource from "../../../../assets/photos/players/player-22.jpeg";
import player8ImageSource from "../../../../assets/photos/players/player-8.jpeg";
import player200ImageSource from "../../../../assets/photos/players/player-200.jpeg";
import player5ImageSource from "../../../../assets/photos/players/player-5.jpeg";
import player7ImageSource from "../../../../assets/photos/players/player-7.jpeg";
import player3ImageSource from "../../../../assets/photos/players/player-3.jpeg";
import player38ImageSource from "../../../../assets/photos/players/player-38.jpeg";
import player9ImageSource from "../../../../assets/photos/players/player-9.jpeg";
import player18ImageSource from "../../../../assets/photos/players/player-18.jpeg";
import player19ImageSource from "../../../../assets/photos/players/player-19.jpeg";

const chachosSquadImages = [
  {
    img: player10ImageSource,
    shirt: 10,
  },
  {
    img: player2ImageSource,
    shirt: 2,
  },
  {
    img: player23ImageSource,
    shirt: 23,
  },
  {
    img: player14ImageSource,
    shirt: 14,
  },
  {
    img: player32ImageSource,
    shirt: 32,
  },
  {
    img: player4ImageSource,
    shirt: 4,
  },
  {
    img: player15ImageSource,
    shirt: 15,
  },
  {
    img: player99ImageSource,
    shirt: 99,
  },
  {
    img: player22ImageSource,
    shirt: 22,
  },
  {
    img: player8ImageSource,
    shirt: 8,
  },
  {
    img: player200ImageSource,
    shirt: 200,
  },
  {
    img: player5ImageSource,
    shirt: 5,
  },
  {
    img: player7ImageSource,
    shirt: 7,
  },
  {
    img: player3ImageSource,
    shirt: 3,
  },
  {
    img: player38ImageSource,
    shirt: 38,
  },
  {
    img: player9ImageSource,
    shirt: 9,
  },
  {
    img: player18ImageSource,
    shirt: 18,
  },
  {
    img: player19ImageSource,
    shirt: 19,
  },
];

export default chachosSquadImages;
